import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue/src'

Vue.use(BootstrapVue, {})
